/**
 * AdminIcons — the small line-icon set used by the admin sidebar nav.
 * Extracted from AdminShell.tsx to keep the shell focused on layout/nav.
 * Each takes a `color` so the shell can tint active vs idle rows.
 */
import Svg, { Circle, Path, Rect } from "react-native-svg";

export function IconDashboard({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Rect x={1} y={1} width={5} height={5} rx={1} stroke={color} strokeWidth={1.1} />
      <Rect x={8} y={1} width={5} height={5} rx={1} stroke={color} strokeWidth={1.1} />
      <Rect x={1} y={8} width={5} height={5} rx={1} stroke={color} strokeWidth={1.1} />
      <Rect x={8} y={8} width={5} height={5} rx={1} stroke={color} strokeWidth={1.1} />
    </Svg>
  );
}

export function IconCalendar({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Rect x={1.5} y={2.5} width={11} height={10} rx={1.2} stroke={color} strokeWidth={1.1} />
      <Path d="M1.5 5.2h11" stroke={color} strokeWidth={1.1} />
      <Path d="M4.5 1.2v2.6M9.5 1.2v2.6" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconInquiries({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path
        d="M2 4a1.5 1.5 0 0 1 1.5-1.5h7A1.5 1.5 0 0 1 12 4v4.5a1.5 1.5 0 0 1-1.5 1.5H6L3 12.5V10H3.5A1.5 1.5 0 0 1 2 8.5V4z"
        stroke={color}
        strokeWidth={1.1}
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function IconUsers({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Circle cx={7} cy={5} r={2.4} stroke={color} strokeWidth={1.1} />
      <Path d="M2.5 12c0-2.2 2-3.6 4.5-3.6S11.5 9.8 11.5 12" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconStudents({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M0.8 5.2L7 2.5l6.2 2.7L7 7.9 0.8 5.2z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M3.6 6.6V9.5c0 0.6 1.5 1.6 3.4 1.6s3.4-1 3.4-1.6V6.6" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M12 5.5V8.5" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconClients({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M1.5 12.5h11" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M2.5 12.5V4.5L7 2l4.5 2.5v8" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M5 12.5V6.5M7 12.5V6.5M9 12.5V6.5" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconCampus({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M1.5 12.5h11" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M2 12.5V6L7 3l5 3v6.5" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Rect x={5.5} y={8} width={3} height={4.5} stroke={color} strokeWidth={1.1} />
      <Path d="M7 1.5L9 3.2H5L7 1.5z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
    </Svg>
  );
}

export function IconTeam({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Circle cx={5} cy={5} r={2} stroke={color} strokeWidth={1.1} />
      <Circle cx={10.5} cy={5.8} r={1.6} stroke={color} strokeWidth={1.1} />
      <Path d="M1.5 11.8c0-1.8 1.5-3 3.5-3s3.5 1.2 3.5 3" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M9 11.8c0-1.4 1-2.4 2.5-2.4S14 10.4 14 11.8" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconCompetitions({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M4 2h6v3.5a3 3 0 0 1-6 0V2z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M4 3.5H2.2c0 1.7 1 3 1.8 3M10 3.5h1.8c0 1.7-1 3-1.8 3" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M7 8.5v3M5 12h4" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconMegaphone({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M2 5.5L11 2.5v9L2 8.5v-3z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M2 5.5h-.5a1 1 0 0 0 0 3H2" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M5 8.7l.6 2.5a1 1 0 0 0 1.9-.4L7 8.5" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
    </Svg>
  );
}

export function IconPlus({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Circle cx={7} cy={7} r={5.5} stroke={color} strokeWidth={1.1} />
      <Path d="M7 4.2v5.6M4.2 7h5.6" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconChart({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M1.8 1.5v9.2c0 0.9 0.7 1.6 1.6 1.6h9.1" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M4.5 9V6.5M7 9V3.8M9.5 9V5.4" stroke={color} strokeWidth={1.3} strokeLinecap="round" />
    </Svg>
  );
}

export function IconDatabase({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M7 1.5c2.8 0 5 0.9 5 2v7c0 1.1-2.2 2-5 2s-5-0.9-5-2v-7c0-1.1 2.2-2 5-2z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M2 3.5c0 1.1 2.2 2 5 2s5-0.9 5-2M2 7c0 1.1 2.2 2 5 2s5-0.9 5-2" stroke={color} strokeWidth={1.1} />
    </Svg>
  );
}

export function IconSearch({ color, size = 14 }: { color: string; size?: number }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 14 14" fill="none">
      <Circle cx={6} cy={6} r={4.2} stroke={color} strokeWidth={1.1} />
      <Path d="M9.1 9.1L12.5 12.5" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconGavel({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M2.5 4.5l3-3 4.5 4.5-3 3-4.5-4.5z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M7.5 6.5L11 10M9 4l1 1" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M2 12h6" stroke={color} strokeWidth={1.4} strokeLinecap="round" />
    </Svg>
  );
}

export function IconEnvelope({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Rect x={1.5} y={3} width={11} height={8} rx={1.2} stroke={color} strokeWidth={1.1} />
      <Path d="M1.7 3.8L7 8l5.3-4.2" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
    </Svg>
  );
}

export function IconGlobe({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Circle cx={7} cy={7} r={5.5} stroke={color} strokeWidth={1.1} />
      <Path d="M1.5 7h11" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <Path d="M7 1.5c2 1.6 3 3.5 3 5.5s-1 3.9-3 5.5c-2-1.6-3-3.5-3-5.5s1-3.9 3-5.5z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
    </Svg>
  );
}

export function IconDollar({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path
        d="M7 2v10M9.5 4.5C9 3.5 8 3 7 3c-1.4 0-2.5.8-2.5 2 0 2.6 5 1.4 5 4 0 1.2-1.1 2-2.5 2-1 0-2-.5-2.5-1.5"
        stroke={color}
        strokeWidth={1.1}
        strokeLinecap="round"
      />
    </Svg>
  );
}

export function IconAuditLog({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M3 1.5h6l2 2V12a.5.5 0 0 1-.5.5h-7A.5.5 0 0 1 3 12V2a.5.5 0 0 1 .5-.5z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M9 1.5V3.5h2" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M5 6h4M5 8h4M5 10h2.5" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
    </Svg>
  );
}

export function IconShield({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Path d="M7 1.5l4.5 1.5v4.2c0 2.6-2 4.5-4.5 5.3-2.5-.8-4.5-2.7-4.5-5.3V3L7 1.5z" stroke={color} strokeWidth={1.1} strokeLinejoin="round" />
      <Path d="M5 7.2l1.5 1.5L9 6.2" stroke={color} strokeWidth={1.1} strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  );
}

export function IconClipboardCheck({ color }: { color: string }) {
  return (
    <Svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <Rect x={2.5} y={2.5} width={9} height={10} rx={1.2} stroke={color} strokeWidth={1.1} />
      <Rect x={5} y={1.2} width={4} height={2.2} rx={0.5} stroke={color} strokeWidth={1.1} fill="none" />
      <Path d="M5 8.2l1.4 1.4L9.2 6.6" stroke={color} strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  );
}
